import BN from "bignumber.js";

const converter = (value, { conversionRate } = { conversionRate: 1e9 }) => {
  return new BN(value).dividedBy(conversionRate).valueOf();
};

export default converter;
